<p class="font-base text-neutral-600 font-normal text-md pt-2 pb-3 border-b border-neutral-200">
  {{ content }}
</p>
